export default __webpack_public_path__ + "static/media/palantir_logo.b1a6d1bc.png";